module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormList) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFormList = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Lote " + _vm._s(_vm.parent.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFormList = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [(_vm.parent.formData.lote) ? _c('eSocial', {
    key: _vm.formData.id + '-' + (_vm.showForm ? 1 : 0),
    attrs: {
      "layout": _vm.parent.formData.layout,
      "lote": _vm.parent.formData.lote,
      "avulso": _vm.parent.formData.avulso ? _vm.parent.formData.avulso : 0
    }
  }) : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e57592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/item/index.vue
// module id = 1437
// module chunks = 45